import { UiEvent } from '../utils/ui-event';

export class GlobalClickTrackingHomepage {
	constructor() {
		let links: NodeListOf<HTMLAnchorElement>;

		// Sticky header
		links = document.querySelectorAll('.header.sticky a');
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					if (link.hash.length > 0) {
						UiEvent.trackUIEvent(
							'header-sticky',
							'anchor-hash-link',
							event.type,
							link.hash
						);
					} else {
						UiEvent.trackUIEvent(
							'header-sticky',
							'anchor-link',
							event.type,
							new URL(link.href).pathname
						);
					}
				},
				{ once: true }
			);
		});

		// Default header
		links = document.querySelectorAll('.header.default a:not(.login)');
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					if (link.hash.length > 0) {
						UiEvent.trackUIEvent(
							'header-default',
							'anchor-hash-link',
							event.type,
							link.hash
						);
					} else {
						UiEvent.trackUIEvent(
							'header-default',
							'anchor-link',
							event.type,
							new URL(link.href).pathname
						);
					}
				},
				{ once: true }
			);
		});

		// Mobile navigation toggle
		document.querySelector('.burger.mobile-navigation-toggle')?.addEventListener(
			'click',
			(event) => {
				UiEvent.trackUIEvent('mobile-navigation', 'mobile-navigation-toggle', event.type);
			},
			{ once: true }
		);

		// Login button
		document.querySelector('.menu > .login')?.addEventListener(
			'click',
			(event) => {
				UiEvent.trackUIEvent(
					'login-form',
					document.body.classList.contains('login-form-is-visible')
						? 'hide-login-form'
						: 'show-login-form',
					event.type
				);
			},
			{ once: true }
		);

		// Login form
		document.querySelector('.signInWithApple')?.addEventListener(
			'click',
			(event) => {
				UiEvent.trackUIEvent('login-form', 'apple-button', event.type);
			},
			{ once: true }
		);

		document.querySelector('#loginFormSubmit')?.addEventListener(
			'click',
			(event) => {
				UiEvent.trackUIEvent('login-form', 'submit-button', event.type);
			},
			{ once: true }
		);

		// Footer internal links
		links = document.querySelectorAll('footer.internal-links a');
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					UiEvent.trackUIEvent(
						'footer',
						'anchor-link',
						event.type,
						new URL(link.href).pathname
					);
				},
				{ once: true }
			);
		});

		// Footer external links
		links = document.querySelectorAll('footer.external-links a');
		links.forEach((link) => {
			link.addEventListener(
				'click',
				(event: Event) => {
					UiEvent.trackUIEvent(
						'footer',
						'anchor-link',
						event.type,
						new URL(link.href).hostname
					);
				},
				{ once: true }
			);
		});
	}
}
